import moment from "moment";

export const manipulatedLineItems = (item) => {
  const storeName = item?.store?.store_name.split(".")[0];

  let counter = 0;
  const total_products = item?.line_items?.map((line_item) => {
    counter++;
    const manipulateOrder = {
      orderId: item?._id,
      productWithOrderNumber: `${
        item.shopify_order_number
      }-${String.fromCharCode(64 + counter)}`,
      totalProductCost:item?.pricing?.product_cost,
      totalShippingCost:item?.pricing?.total_shipping_cost,
      orderNumber: item.shopify_order_number,
      orderStatus: item.status,
      storeName: item?.store?.store_name,
      storeId: item?.store?._id?.toString(),
      productName: line_item?.product_title,
      productVariant: line_item?.supplier_variant_id,
      shopifyOrderDetailId: item.shopify_order_id,
      fulfillableQuantity: line_item?.fulfillable_quantity,
      productImageLink: line_item?.variant_image || "Not available",
      linkOfProductPage:
      `https://${item?.store?.store_name}/products/${line_item?.handle}` ||
      "Not available",
      price: line_item?.price,
      shopifyProductId: line_item?.shopify_product_id,
      financialStatus:item?.financial_status,
      quantity: line_item?.quantity,
      sku: line_item?.sku,
      totalDiscount: 0,
      shopifyVariantId: line_item?.shopify_variant_id,
      clientName: item?.user?.first_name + " " + item?.user?.last_name,
      customerFirstName: item?.customer_info?.first_name,
      customerLastName: item?.customer_info?.last_name,
      paidByShopOwner: storeName,
      dateOfPayment:
        item.status === "Processing"
          ? moment(item.updatedAt).format("YYYY-MM-DD")
          : "Not paid",
      customerPhone: item?.customer_info?.phone,
      customerEmail: item?.customer_info?.email,
      address1: item?.shipping_details?.address1,
      address2: item?.shipping_details?.address2,
      city: item?.shipping_details?.shipping_city,
      country: item?.shipping_details?.shipping_country,
      zipCode: item?.shipping_details?.zip,
      trackingNumber: item?.tracking_info?.tracking_number,
      shippingMethod:
        line_item?.product_type === "non_electric_regular" &&
        item?.shipping_method === "premium"
          ? "premium"
          : "regular"
    };

    return manipulateOrder;
  });
  return total_products
};
